import { PerspectiveCamera } from 'three';

class Camera extends PerspectiveCamera {
    static instance?: Camera;
    constructor() {
        super(30, window.innerWidth / window.innerHeight, 0.2, 1000);
    }

    static getInstance() {
        if (!Camera.instance) Camera.instance = new this();
        return Camera.instance;
    }

    destroy() {
        delete Camera.instance;
    }
}

export default Camera;
